<template>
    <v-container fluid class="py-0 grey darken-4">
        <v-layout row wrap justify-start>            
            <v-flex xs3>
                <v-layout column>
                    <v-flex>
                        <v-card class="grey darken-4 px-4" flat dark fill-height>
                            <v-card-title>
                                Liste
                            </v-card-title>
                            <v-card-text class="pt-0">
                                <v-radio-group v-model="list" row :mandatory="false">
                                    <v-radio
                                        v-for="list in lists"
                                        :key="list.name"
                                        :label="list.name"
                                        :value="list"                                         
                                    ></v-radio>
                                </v-radio-group>
                            </v-card-text>                            
                        </v-card>
                    </v-flex>
                </v-layout>                
            </v-flex>
            <v-flex xs3>
                <v-layout column>
                    <v-flex>
                        <v-card class="grey darken-4" dark flat fill-height>
                            <v-card-title>
                                Suche
                            </v-card-title>
                            <v-text-field
                                class="mt-3 pb-5"
                                flat
                                name="search"
                                label="search"
                                id="search"
                                v-model="word"
                                solo-inverted
                                clearable
                                prepend-inner-icon="search"
                            >                    
                            </v-text-field> 
                            <!-- <code>{{ dataobject }}</code> -->
                        </v-card>
                    </v-flex>                    
                </v-layout>                                
            </v-flex>
            <v-flex xs4>                
                <v-layout column>
                    <v-flex>
                        <v-card class="grey darken-4 px-4" dark flat fill-height>
                            <v-card-title>                                
                                Tags
                                
                            </v-card-title>
                            <v-card-text class="pt-0">
                                <tagselect
                                    :attributes="tagdata.attributes"
                                    vuexnamespace="search"
                                    v-model="searchtags"
                                    >

                                </tagselect>
                            </v-card-text>                            
                        </v-card>
                    </v-flex>
                </v-layout>     
            </v-flex>
            <v-flex xs2>
                <v-btn small 
                       flat 
                       light 
                       class="white"
                       v-on:click.stop="clearSearch"
                >
                    <span><v-icon small>close</v-icon> Suche leeren</span>
                     
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>   
          
                        
            
</template>
<script>

import tagselect from "../forms/TagSelect.vue"
export default {   
    components:{
        tagselect:tagselect
    },    
    data() {
        return {
            
        }
    },
    methods: {
        clearSearch() {
            this.$store.commit('search/SEARCH_INIT_SEARCH')
            this.$store.commit('search/SEARCH_SET_SHOW',true)
        }
    },
    watch:{
        list(){
            if(this.list!=null)
                this.$router.push({name:this.list.target})
        }
        
    },
    computed: {                 
        word: {
            get () {
                return this.$store.getters['search/data']('word')
            },
            set (value) {
                this.$store.commit('search/SEARCH_SET_WORD', value)
            }
        }, 
        list: {
            get () {
                return this.$store.getters['search/data']('list')
            },
            set (value) {
                this.$store.commit('search/SEARCH_SET_LIST', value)                
            }
        }, 
        searchtags: {
            get () {
                return this.$store.getters['search/data']('tags')
            },
            set (value) {
                this.$store.commit('search/SEARCH_SET_TAGS', value)                
            }
        }, 
        tags() {return this.$store.getters['tags/tags']},        
        lists (){return this.$store.getters['search/lists']},
        tagdata(){return this.$store.getters['search/tagdata']},
        dataobject(){return this.$store.getters['search/dataobject']}
                
    },
    
    
}
</script>
